//import {cartItems} from '../../@crema/services/db/ecommerce/ecommerceData';
import {
  CartItems,
  CustomersData,
  FilterData,
  ProductData,
  RecentOrders,
  //OrderDetails,
  //OrderDetail,
  CinemaList,
  PhonePrefixList,
  //OrderHistory,
  ConfirmOrderStatus,
  RegionList,
} from '../../types/models/ecommerce/EcommerceApp';
import {
  ADD_CART_ITEM,
  GET_CUSTOMERS,
  GET_ECOMMERCE_LIST,
  //SET_ECOMMERCE_LIST,
  GET_RECENT_ORDER,
  REMOVE_CART_ITEM,
  SET_FILTER_DATA,
  SET_PRODUCT_DATA,
  SET_PRODUCT_VIEW_TYPE,
  UPDATE_CART_ITEM,
  GET_MENU_ITEM,
  NEW_CSO_ORDER,
  CONFIRM_CSO_ORDER_STATUS,
  SET_ORDER_DATA,
  SET_NEW_ORDER,
  GET_CINEMA_LIST,
  GET_PHONE_PREFIX,
  GET_ORDER_HISTORY,
  GET_WEBSITE_STATUS,
  GET_REGION_LIST,
  CLEAR_CART_ITEM,
  GET_CONFIRM_ORDER_STATUS,
} from '../../types/actions/Ecommerce.action';
import {AppActions} from '../../types';
import { confirmAlert } from 'react-confirm-alert';
import '../../shared/styles/vendors/react-confirm-alert.css'
import {maxOrder, maxItems, phase} from '../../shared/constants/AppConst';
//import { stringify } from 'qs';
export enum VIEW_TYPE {
  LIST = 1,
  GRID = 2,
}

const initialState: {
  ecommerceList: ProductData[];
  viewType: number;
  currentProduct: ProductData | null;
  orderCount: number;
  filterData: FilterData;
  cartItems: CartItems[];
  recentOrders: RecentOrders[];
  customers: CustomersData[];
  customerCount: number;
  //orderDetails: OrderDetails | null;
  currentOrder: RecentOrders | null;
  newOrder: RecentOrders | null;
  confirmOrderStatus: ConfirmOrderStatus | null;
  cinemaList: CinemaList [];
  phonePrefixList: PhonePrefixList [];
  //orderHistory: OrderHistory[];
  websiteStatus : string;
  regionList: RegionList [];
} = {
  ecommerceList: [],
  viewType: VIEW_TYPE.LIST,
  currentProduct: null,
  orderCount: 0,
  filterData: {
    title: '',
    brand: [],
    ideaFor: [],
    discount: [],
    color: [],
    type: [],
    rating: [],
  },
  cartItems: [],
  recentOrders: [],
  customers: [],
  customerCount: 0,
  //orderDetails: null,
  currentOrder:null,
  newOrder:null,
  confirmOrderStatus:null,
  cinemaList: [],
  phonePrefixList: [],
  //orderHistory: [],
  websiteStatus: '',
  regionList: [],
};

const Ecommerce = (state = initialState, action: AppActions) => {
  switch (action.type) {
    case GET_ECOMMERCE_LIST:
      return {
        ...state,
        ecommerceList: action.payload,
      };

    case SET_PRODUCT_VIEW_TYPE:
      return {
        ...state,
        viewType: action.payload,
      };

    case SET_FILTER_DATA:
      return {
        ...state,
        filterData: action.payload,
      };

    case SET_PRODUCT_DATA:
      return {
        ...state,
        currentProduct: action.payload,
      };

    case GET_RECENT_ORDER:
      return {
        ...state,
        recentOrders: action.payload,
      };

    case UPDATE_CART_ITEM:
      
      return {
        ...state,
        cartItems: state.cartItems.map(item =>
          item.ProductCode === action.payload.ProductCode ? action.payload : item,
        ),
      };

    case ADD_CART_ITEM:
      let cartItems: CartItems[] = [];
      const inCart = state.cartItems.some(item => +item.ProductCode === +action.payload.data.ProductCode);

      if (inCart) 
      {
        cartItems = state.cartItems.map(item => 
        {
              if (+item.ProductCode === +action.payload.data.ProductCode) 
              {
                if ((item.count + action.payload.counter) <= maxItems){ //check the quantity of item
                  item.count = +item.count + action.payload.counter;
                }
                else
                {
                    item.count = maxItems;
                    //alert('You can only add a maximum of 10 items to cart in single purchase'); 
                    confirmAlert({
                      title: 'Hello. Cannot.',
                      message: 'You can only order a maximum of '+maxItems+' of the particular concession item in a single transaction.',
                      buttons: [
                        {
                          label: 'Ok',
                          onClick: () => {}
                        }
                      ]
                    });
                }
              }
          return item;
        });

        return {
          ...state,
          cartItems: cartItems,
        };
      } else {
        //check if the carts have more than 10 orders
        if(state.cartItems.length < maxOrder){
          const cartData: CartItems = {
            Seq: action.payload.data.Seq,
            ProductCode: action.payload.data.ProductCode,
            Description: action.payload.data.Description,
            Quantity: action.payload.data.Quantity,
            SalesAmount: action.payload.data.SalesAmount,
            hlbDiscountFlag: action.payload.data.hlbDiscountFlag,
            ImageUrl: action.payload.data.ImageUrl,
            DetailDescription: action.payload.data.DetailDescription,
            IsSoldOut: action.payload.data.IsSoldOut,
            SoldOutMessage: action.payload.data.SoldOutMessage,
            Limit_By_Tkt_Qty: action.payload.data.Limit_By_Tkt_Qty,
            // Taxes: {
            //   Type: action.payload.Taxes.Type,
            //   Code: action.payload.Taxes.Code,
            //   Id: action.payload.Taxes.Id,
            //   Rate:action.payload.Taxes.Rate,
            //   Enabled: action.payload.Taxes.Enabled,
            //   Inclusive:action.payload.Taxes.Inclusive,
            // },
            count: action.payload.counter,
          };
          cartItems = state.cartItems.concat(cartData);
        }else {
          cartItems = state.cartItems;
          confirmAlert({
            title: 'Hello. Cannot.',
            message:'You can only check out a maximum of '+maxOrder+' orders each time.',
            buttons: [
              {
                label: 'Ok',
                onClick: () => {}
              }
              ]
            });
        }

        return {
          ...state,
          cartItems: cartItems,
        };
      }

      case REMOVE_CART_ITEM:
        return {
          ...state,
          cartItems: state.cartItems.filter(
            item => item.ProductCode !== action.payload.ProductCode,
          ),
        };

      case CLEAR_CART_ITEM:
        return {
          ...state,
          cartItems: [],
        };

    case GET_CUSTOMERS:
      return {
        ...state,
        customers: action.payload.customers,
        customerCount: action.payload.customerCount,
      };

      case GET_MENU_ITEM:

        let tmpChild:ProductData[] = [];
      //To get ChildData only
          for(var countParents=0; countParents<action.payload.Econs.length;countParents++)
          {
            for(var countChild=0; countChild<action.payload.Econs[countParents].Child.length; countChild++)
            {	
              tmpChild =
              [
                ...tmpChild,
                {
                  Seq: action.payload.Econs[countParents].Child[countChild].Seq,
                  ProductCode: action.payload.Econs[countParents].Child[countChild].ProductCode,
                  Description: action.payload.Econs[countParents].Child[countChild].Description,
                  Quantity: action.payload.Econs[countParents].Child[countChild].Quantity,
                  SalesAmount: action.payload.Econs[countParents].Child[countChild].SalesAmount,
                  hlbDiscountFlag: action.payload.Econs[countParents].Child[countChild].hlbDiscountFlag,
                  ImageUrl: action.payload.Econs[countParents].Child[countChild].ImageUrl,
                  DetailDescription: action.payload.Econs[countParents].Child[countChild].DetailDescription,
                  IsSoldOut: action.payload.Econs[countParents].Child[countChild].IsSoldOut,
                  SoldOutMessage: action.payload.Econs[countParents].Child[countChild].SoldOutMessage,
                  Limit_By_Tkt_Qty: action.payload.Econs[countParents].Child[countChild].Limit_By_Tkt_Qty,
                  Taxes: {
                    Type: action.payload.Econs[countParents].Child[countChild].Taxes.Type,
                    Code: action.payload.Econs[countParents].Child[countChild].Taxes.Code,
                    Id: action.payload.Econs[countParents].Child[countChild].Taxes.Id,
                    Rate:action.payload.Econs[countParents].Child[countChild].Taxes.Rate,
                    Enabled: action.payload.Econs[countParents].Child[countChild].Taxes.Enabled,
                    Inclusive:action.payload.Econs[countParents].Child[countChild].Taxes.Inclusive,
                  },
                }
              ]
            } 
        }
      return {
        ...state,
        ecommerceList: tmpChild,
      };
  
    case NEW_CSO_ORDER:
      let newOrderList: RecentOrders[] = [];//use to form whole order list with new order
      let newOrderData: RecentOrders | null; //Use to select the latest order and display in screen
      let tmpOrder: RecentOrders | null; //Use to select the latest order and reorder/rearrange

      let datalist:RecentOrders[] = [];
      let trxnNoList: {TrxnNo:string}[] = [];
      let trxnNo = 0;

      //get TrxnNo from localStorage and select the latest TrxnNo to display in screen
      if(localStorage.getItem(phase+'_GSC_PendingOrder') !== null)
      {
        trxnNoList = JSON.parse(localStorage.getItem(phase+'_GSC_PendingOrder') || '') || [];
        for(var count=0; count < trxnNoList.length; count++)
        {
          if(parseInt(trxnNoList[count].TrxnNo) > trxnNo)
          {
            trxnNo = parseInt(trxnNoList[count].TrxnNo);
          }
        }
      }

      //If status return ok
      if(action.payload.Response.Body.Status.RespStatus === '000')
      {
        datalist = action.payload.Response.Body.HistoryDetail;
        // find the object with latest TrxnNo
        if(trxnNo !== 0)
        {
          tmpOrder = datalist.find(data => data.Transaction.TrxnNo.match(trxnNo.toString()) || null ) || null;
        }else
        {
          tmpOrder = datalist[0];
        }

        if(tmpOrder !== null)
        {
          const data: RecentOrders = 
          { 
            Status: action.payload.Response.Body.Status,
            Transaction: tmpOrder.Transaction,
            Detail: tmpOrder.Detail,
            Total: tmpOrder.Total,
            Payment: tmpOrder.Payment,
            QRCode: tmpOrder.QRCode,
          };

          //Set currentOrder to new Order
          newOrderData = data;
        }
        else
        {
          newOrderData = datalist[0];
        }
        if(localStorage.getItem(phase+'_GSC_OrderList') === null)
        {
          newOrderList = newOrderList.concat(datalist);
          //save to localstorage'
          localStorage.setItem(phase+'_GSC_OrderList', JSON.stringify(newOrderList));
        }
        else
        {
          //get current localStorage OrderList
          let oldOrderList: RecentOrders[] = [];
          oldOrderList = JSON.parse(localStorage.getItem(phase+'_GSC_OrderList') || '') || [];

          //if same record, filter/remove oldOrderList data 
          datalist.forEach( input =>
          {
            oldOrderList = oldOrderList.filter(data => data.Transaction.TrxnNo !== input.Transaction.TrxnNo);
          })

          //Add new  data
          newOrderList = newOrderList.concat(datalist , oldOrderList); //bind old and new data list, put new record at top

          //Reorder list
          //newOrderList.sort();
          newOrderList.sort((x, y) => +new Date(x.Transaction.TrxnDateTime) - +new Date(y.Transaction.TrxnDateTime)); //ASC by TrxnDateTime
          newOrderList.reverse(); //Reverse it to DESC

          //Clear data if more than 30 records
          newOrderList = newOrderList.slice(0,30);

          //save to localstorage
          localStorage.setItem(phase+'_GSC_OrderList', JSON.stringify(newOrderList));

          //if successfully add record to GSC_OrderList and Payment Status successful, clear GSC_PendingOrder
          let pendOrderList: {TrxnNo:string}[] = [];
          pendOrderList = JSON.parse(localStorage.getItem(phase+'_GSC_PendingOrder') || '') || [];

          //Reform new GSC_PendingOrder list
          newOrderList.forEach( input => 
          {
            const duplicate = pendOrderList.some(data => +data.TrxnNo === +input.Transaction.TrxnNo);
            if(duplicate && input.Payment.PymtStatus !== 'P')
            {
              pendOrderList = pendOrderList.filter(data => data.TrxnNo !== input.Transaction.TrxnNo);
              //save new filtered list in localstorage
              localStorage.setItem(phase+'_GSC_PendingOrder', JSON.stringify(pendOrderList));
            }
          } )
        }

    }else //if Status return false
    {
      const data: RecentOrders = 
        { 
          Status:action.payload.Response.Body.Status,
          Transaction:
          {
            TrxnOutletId: '',
            TrxnNo: '',
            TrxnDateTime: '',
            HallNo: '',
            ShowTime: '',
            PhoneNo: '',
            Nickname: '',
          },
          Detail: [],
          Total:
          {
            TrxnAmt: 0,
          },
          Payment:
          {
            PymtCode: '',
            PymtDesc: '',
            PymtAmt: 0,
            PymtStatus: '',
            PymtStatusDesc: '',
            PymtDiscount: 0,
          },
          QRCode:'',
        };

        //Set currentOrder to new Order
        newOrderData = data;
      }

      return {
        ...state,
        newOrder: newOrderData,
        //cartItems: [], //Clear CartItems
      };

      case CONFIRM_CSO_ORDER_STATUS:
        //let OrderList: ConfirmOrderStatus[] = [];
        let neworder: RecentOrders | null;
        //let pendingOrderList: {TrxnNo: string}[] = [];
        let currOrderStatus: ConfirmOrderStatus | null;

        //If status return ok
        if(action.payload.data.Response.Body.Status.RespStatus === '000')
        {
          const data: ConfirmOrderStatus = 
          { 
            Status:action.payload.data.Response.Body.Status,
            BookingId: action.payload.data.Response.Body.BookingId,
            Emall_req: action.payload.data.Response.Body.Emall_req,
          };
  
          //Set currentOrder 
          currOrderStatus = data;
          neworder = null;

          //show Alert
          confirmAlert({
            title: 'Are you sure you want to confirm your order?',
            //message: 'Are you sure to confirm your order?',
            buttons: [
              {
                label: 'Yes',
                onClick: () => {
                  action.payload.redirectToPayment(data.Emall_req, data.BookingId);
                  action.payload.setSubmitting(true);
                },
              },
              {
                label: 'Cancel',
                onClick: () => {
                  action.payload.redirectToMenuList(data.BookingId);
                  action.payload.setSubmitting(false);
                },
              },
            ],
            closeOnClickOutside: false,
          });

          //setSubmitting
  
        }else //if Status return false
        { 
          const data: ConfirmOrderStatus = 
          { 
            Status:action.payload.data.Response.Body.Status,
            BookingId: '',
            Emall_req: '',
          };

          //Set currentOrder
          currOrderStatus = data;

          const newdata: RecentOrders = 
          { 
            Status:action.payload.data.Response.Body.Status,
            Transaction:
            {
              TrxnOutletId: '',
              TrxnNo: '',
              TrxnDateTime: '',
              HallNo: '',
              ShowTime: '',
              PhoneNo: '',
              Nickname: '',
            },
            Detail: [],
            Total:
            {
              TrxnAmt: 0,
            },
            Payment:
            {
              PymtCode: '',
              PymtDesc: '',
              PymtAmt: 0,
              PymtStatus: '',
              PymtStatusDesc: '',
              PymtDiscount: 0, 
            },
            QRCode:'',
          };

          //Set currentOrder to new Order
          neworder = newdata;

          //Alert for fail
          confirmAlert({
            title: action.payload.data.Response.Body.Status.RespDesc ,
            //message: 'Please try again later or contact our customer service.',
            buttons: [
              {
                label: 'OK',
                onClick: () => {
                  action.payload.setSubmitting(false);
                },
              }
            ],
            closeOnClickOutside: false,
          });
        }
  
        return {
          ...state,
          confirmOrderStatus: currOrderStatus,
          newOrder: neworder,
          //cartItems: [], //Clear CartItems
        };

    case SET_NEW_ORDER:
      return {
        ...state,
        newOrder: action.payload,
      };
  
    case SET_ORDER_DATA:
      return {
        ...state,
        currentOrder: action.payload,
      };

    case GET_CINEMA_LIST:
      let tmpCinemaList: CinemaList[] = [];
      for(let loccount=0; loccount<action.payload.Response.Body.Location.length; loccount++)
      {	
        //checkDuplicate
        if(! tmpCinemaList.some(item => +item.OutletId === +action.payload.Response.Body.Location[loccount].OutletId))
        {
          tmpCinemaList =
          [
            ...tmpCinemaList,
            {
              OutletId: action.payload.Response.Body.Location[loccount].OutletId,
              OutletName: action.payload.Response.Body.Location[loccount].OutletName,
              Region: action.payload.Response.Body.Location[loccount].Region,
              Address: action.payload.Response.Body.Location[loccount].Address,
              StateCode: action.payload.Response.Body.Location[loccount].StateCode,
              StateDesc: action.payload.Response.Body.Location[loccount].StateDesc,
              Epay_Enabled: action.payload.Response.Body.Location[loccount].Epay_Enabled,
              Epay_Hidden: action.payload.Response.Body.Location[loccount].Epay_Hidden,
            }
          ]
        }
      } 
      return {
        ...state,
        cinemaList: tmpCinemaList,
      };

    case GET_PHONE_PREFIX:
      let tmpPhonePrefixList: PhonePrefixList[] = [];
      for(let codecount=0; codecount<action.payload.Response.Body.Phone.length; codecount++)
      {	
        //checkDuplicate
        if(! tmpPhonePrefixList.some(item => +item.CountryCode === +action.payload.Response.Body.Phone[codecount].CountryCode))
        {
          tmpPhonePrefixList =
          [
            ...tmpPhonePrefixList,
            {
              CountryCode: action.payload.Response.Body.Phone[codecount].CountryCode,
              Prefix: action.payload.Response.Body.Phone[codecount].Prefix,
            }
          ]
        }
      } 
      return {
        ...state,
        phonePrefixList: tmpPhonePrefixList,
      };

    case GET_ORDER_HISTORY:

      let tmpOrderList : RecentOrders[];
      tmpOrderList = action.payload.Response.Body.HistoryDetail;

      if(localStorage.getItem(phase+'_GSC_PendingOrder')!==null)
      {
        //if successfully add record to GSC_OrderList and Payment Status successful, clear GSC_PendingOrder
        let pendOrderList: {TrxnNo:string}[] = [];
        pendOrderList = JSON.parse(localStorage.getItem(phase+'_GSC_PendingOrder') || '') || [];

        //Reform new GSC_PendingOrder list
        tmpOrderList.forEach( input => 
        {
          const duplicate = pendOrderList.some(data => +data.TrxnNo === +input.Transaction.TrxnNo);
          if(duplicate && input.Payment.PymtStatus !== 'P')
          {
            pendOrderList = pendOrderList.filter(data => data.TrxnNo !== input.Transaction.TrxnNo);
            //save new filtered list in localstorage
            localStorage.setItem(phase+'_GSC_PendingOrder', JSON.stringify(pendOrderList));
          }
        } )

        //if Pending Order List is 0, then clear refresh count
        if(pendOrderList.length === 0)
        {
          localStorage.removeItem(phase+'_GSC_RefreshCount');
        }
      }
      else
      {
        localStorage.removeItem(phase+'_GSC_RefreshCount');
      }

      localStorage.removeItem(phase+'_GSC_OrderList');
      localStorage.setItem(phase+'_GSC_OrderList', JSON.stringify(tmpOrderList));

      return {
        ...state,
        recentOrders: tmpOrderList,
      };

    //Get Website Status C : ComingSoon; M: Maintenance;O: Operation 
    case GET_WEBSITE_STATUS:
      return {
        ...state,
        websiteStatus: action.payload.Response.Body.ServiceStatus,
      };
    
    //Get Region List
    case GET_REGION_LIST:
      return {
        ...state,
        regionList: action.payload.Response.Body.Region,
      };

    case GET_CONFIRM_ORDER_STATUS:
      return {
        ...state,
        confirmOrderStatus: state.confirmOrderStatus,
      };

    default:
      return state;
  }
};
export default Ecommerce;
